import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { CourseDeliveryCountsResponse } from 'src/entities/Report.entity';

const requestPath = '/api/v5/reports/course_delivery_counts';
const queryPrefix = 'useCourseDeliveryCountsQuery';

type Params = {
  startOn: string;
  endOn: string;
  shipperNames: string[];
};

const fetchCourseDeliveryCounts = ({ startOn, endOn, shipperNames }: Params) => async () => {
  const response = await axios.get<CourseDeliveryCountsResponse>(requestPath, {
    params: { start_on: startOn, end_on: endOn, shipper_names: shipperNames },
  });
  return response.data;
};

export const useCourseDeliveryCountsQuery = ({ startOn, endOn, shipperNames }: Params) => useQuery(
  [queryPrefix, { startOn, endOn, shipperNames }],
  fetchCourseDeliveryCounts({ startOn, endOn, shipperNames }),
  {
    staleTime: Infinity,
    enabled: Boolean(startOn) && Boolean(endOn) && shipperNames.length > 0,
  },
);
